import { ExtentContext } from "../../lib/context";
export class SelectionContext extends ExtentContext {
    constructor(map, p_layer, m_layer) {
        super(p_layer, map);
        this.selected = [];
        this.name = 'selection';
        this.has_markers = true;
        this.m_layer = m_layer;
        this.zoomed = false;
        this.exit_contexts = ['singleton', 'edit', 'toolbar', 'set'];
    }
    set_extent() {
        this.extent = this.m_layer.source
            .getFeatures()
            .map(f => { var _a; return (_a = f.getGeometry()) === null || _a === void 0 ? void 0 : _a.getExtent(); })
            .filter(ext => typeof ext !== "undefined")
            .reduce((acc, next) => this.conflate_extents(acc, next), [Infinity, Infinity, -Infinity, -Infinity]);
    }
    on_enter() {
        this.selected.forEach(s => this.m_layer.add_marker_to_parcel(s));
    }
    on_exit() {
        this.selected = this.m_layer.selected;
        this.m_layer.clear();
    }
    async click_handler(_, __) {
        return;
    }
    async zoom(b) {
        if (!this.zoomed || b) {
            super.zoom(b);
            this.zoomed = true;
        }
    }
}
